/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment'
import { offersForm } from './form-fields'
import { Button, Divider, Form } from 'antd'
import { showToast } from 'src/core/helpers'
import { useTranslation } from 'next-i18next'
import { SendOutlined } from '@ant-design/icons'
import React, { useState, useEffect } from 'react'
import { CustomResultModal } from 'src/components'
import { SaleOfferApiPayload, SaleOfferFormPayload } from 'src/core/models'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import {
  resetFilterProjectOfferState,
  resetCreateSaleOfferState,
  resetSalesOfferState,
  saleOffersSelector,
  getSaleOfferGroups,
  createSaleOffer,
} from 'src/features'

const CreateStockSalePageContent: React.FC = () => {
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { isMobile } = useWindowSize()
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const [booleanFlags, setBooleanFlags] = useState({
    allow_counter_offer: false,
    show_discount: false
  })

  const {
    filterProject: { data: projectFiltered },
    createSaleOffer: { loading: loadingCreate, success: successCreate }
  } = useAppSelector(saleOffersSelector)

  const onFinish = (values: SaleOfferFormPayload) => {
    if (!projectFiltered) {
      showToast('error', t('SalesOffer.ProjectRequired'))
      return
    }
    const payload: SaleOfferApiPayload = {
      ...values,
      ...booleanFlags,
      expiration_date: !values.expiration_date ? null : moment(values.expiration_date).format('YYYY-MM-DD'),
      project: projectFiltered.id,
    }
    dispatch(createSaleOffer(payload))
  }

  useEffect(() => {
    if (successCreate) {
      setIsModalVisible(true)
      dispatch(resetCreateSaleOfferState())
    }
  }, [successCreate])

  return <>
    <Form onFinish={onFinish} form={form}>
      {/* Sale Offer Group */}
      <offersForm.SaleOfferGroupSelector />

      {/* Client User Email */}
      <offersForm.SaleOfferClientUserEmail />

      {/* Language Selector */}
      <offersForm.SaleOfferLanguageSelector />

      {/* Project Selector */}
      <offersForm.ProjectSaleOfferSelector form={form} />

      {/* Amount */}
      <offersForm.SaleOfferAmount />

      {/* Price per unit */}
      <offersForm.SaleOfferPricePerUnit />

      {/* Currency */}
      <offersForm.SaleOfferCurrency />

      {/* Allow Counter Offer */}
      <offersForm.SaleOfferBooleanFlag
        value={booleanFlags.allow_counter_offer}
        handleChange={(value) => setBooleanFlags({ ...booleanFlags, allow_counter_offer: value })}
        title={t('SalesOffer.AllowCounter')}
        subtitle={t('SalesOffer.AllowCounterLabel')}
      />

      {/* Show Discount */}
      <offersForm.SaleOfferBooleanFlag
        value={booleanFlags.show_discount}
        handleChange={(value) => setBooleanFlags({ ...booleanFlags, show_discount: value })}
        title={t('SalesOffer.ShowDiscount')}
        subtitle={t('SalesOffer.ShowDiscountLabel')}
      />

      {/* Expiration Date */}
      <offersForm.SaleOfferExpirationDate />

      {/* Intro Text */}
      <offersForm.SaleOfferIntroText />

      <Divider />
      <Button
        size='large'
        type='primary'
        block={isMobile}
        htmlType='submit'
        icon={<SendOutlined />}
        loading={loadingCreate}
        className='float-right radius-100'
      >
        {loadingCreate ? t('SalesOffer.CreatingSale') : t('SalesOffer.SubmitSale')}
      </Button>
    </Form>

    <CustomResultModal
      resultType={'success'}
      mainLabel={t('SalesOffer.SaleCreated')}
      isModalVisible={isModalVisible}
      handleCancel={() => {
        form.resetFields()
        dispatch(resetSalesOfferState())
        dispatch(resetFilterProjectOfferState())
        dispatch(getSaleOfferGroups())
      }}
    />
  </>
}

export default CreateStockSalePageContent
